// Port of api/fuel/app/classes/insights/player/recent.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

export default Segment.extend({
	name: 'recent',
	requires: ['init'],
	types: [Constants.TYPE_USER],
	insight: false,
	detail: ['recent'],
	run: function() {
		var list = []
		var limit = this._detail ? 250 : 5
		var plays = Util.sort_by_field(Object.keys(this._data.plays || {}).map(function(key) {
			return this._data.plays[key]
		}.bind(this)), 'd', 'desc')
		var total = plays.length
		if (plays.length > limit) plays = plays.slice(0, limit)

		for (var i = 0; i < plays.length; i++) {
			list.push({
				id: plays[i].g,
				date: plays[i].d
			})
			this._references.games.push(parseInt(plays[i].g, 10))
		}

		return {
			recent: {
				list: list,
				total: total
			}
		}
	}
})
